import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// The teacher's attendance board. Arrivals broadcast instantly when a user
// connects; this poll is how a departure shows up — a user who stops heartbeating
// ages out of the staleness window with no event of their own, so re-rendering
// from the current attendance every REFRESH_MS flips them to Waiting.
const REFRESH_MS = 15_000

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timer = setInterval(() => this.refresh(), REFRESH_MS)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  refresh() {
    get(this.urlValue, { responseKind: "turbo-stream" })
  }
}
